import {Label} from 'lib/ui/typography'
import React from 'react'
import {Controller, UseFormMethods} from 'react-hook-form'
import HTMLEditor from 'lib/ui/form/HTMLEditor'
import Typography from '@material-ui/core/Typography'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import {PointsSummaryProps} from 'Event/template/Cards/Dashboard/Sidebar/SidebarItem/PointsSummary'
import Box from 'lib/ui/Box'
import {EnabledSwitch} from 'lib/ui/form/Switch'
import {onChangeCheckedHandler} from 'lib/dom'
import ImageAssetUploader from 'lib/asset/ImageAssetUploader'
import {useAttendeeVariables} from 'Event'

export default function Settings(props: {
  control: UseFormMethods['control']
  points: PointsSummaryProps
}) {
  const {control, points} = props
  const v = useAttendeeVariables()

  return (
    <>
      <Controller
        name="isEnabled"
        defaultValue={points.isEnabled}
        control={control}
        render={({value, onChange}) => (
          <EnabledSwitch
            checked={value}
            onChange={onChangeCheckedHandler(onChange)}
          />
        )}
      />
      <Controller
        name="logo"
        control={control}
        defaultValue={points.logo || ''}
        render={({onChange, value}) => (
          <ImageAssetUploader
            label="Points Logo"
            onChange={onChange}
            value={value}
            uploadLabel="Upload"
            canResize
            removeButtonProps={{
              'aria-label': 'remove points summary logo',
            }}
            uploadInputProps={{
              'aria-label': 'logo upload',
            }}
          />
        )}
      />
      <Alert severity="info">
        <AlertTitle>Variables</AlertTitle>
        <div>
          <Typography variant="caption">
            {`{{leaderboard_points}} - Attendee's current points`}
          </Typography>
        </div>
        <Typography variant="caption">
          {`{{points_unit}} - Name for points`}
        </Typography>
      </Alert>
      <Box mt={2}>
        <Label>Summary</Label>
        <Controller
          name="summary"
          control={control}
          defaultValue={v(points.summary || '')}
          render={({value, onChange}) => (
            <HTMLEditor
              data={value}
              onChange={onChange}
              toolbar={['bold', 'italic', 'link', 'alignment']}
              customLinks={['Leaderboard']}
            />
          )}
        />
      </Box>
      <Box mt={2}>
        <Label>Description</Label>
        <Controller
          name="description"
          control={control}
          defaultValue={v(points.description || '')}
          render={({value, onChange}) => (
            <HTMLEditor
              data={value}
              onChange={onChange}
              toolbar={['bold', 'italic', 'link', 'alignment']}
              customLinks={['Leaderboard']}
            />
          )}
        />
      </Box>
    </>
  )
}
